import { SET_FLOW } from '../types';

const initialState = {
  flow: {},
};

const flow = (state = initialState, action) => {
  switch (action.type) {
    case SET_FLOW:
      return {
        ...state,
        flow: action.payload,
      };
    default:
      return state;
  }
};

export default flow;
